enum tipoCr {
    CRF = 0,
    CRMV = 1,
    CRM = 2
}

export default tipoCr;